import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { ScrollView, View } from 'native-base';
import React from 'react';

import { Container } from './components/Container';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { HeaderContent } from './components/HeaderContent';
import { RedeemActions } from './components/RedeemActions';
import { RedeemDetailsTable } from './components/RedeemDetailsTable';
import { RedeemSummary } from './components/RedeemSummary';
import { RedeemProviders } from './contexts/redeem-providers';

interface RedeemBatchTicketDetailsProps {}

export const RedeemBatchTicketDetails: React.FC<RedeemBatchTicketDetailsProps> = () => {
  const isMobile = useBreakpointValue({ base: true, sm: false });

  return (
    <RedeemProviders>
      <ScrollView>
        <View minW="container">
          <VStack
            bg={{ base: 'white', sm: 'transparent' }}
            space={Spacing['inline.xxs']}
            flex={1}
            px={{ base: Spacing['inline.xxxs'] }}
            pt={{ base: Spacing['stack.xxxs'], sm: Spacing['stack.xs'] }}>
            <Header />
            <Container>
              <VStack direction={{ base: 'column-reverse', sm: 'column' }}>
                <HeaderContent />
                <RedeemSummary />
              </VStack>
              <RedeemActions />
              <VStack>
                <RedeemDetailsTable />
                {!isMobile && <Footer />}
              </VStack>
            </Container>
          </VStack>
          {isMobile && <Footer />}
        </View>
      </ScrollView>
    </RedeemProviders>
  );
};
